<template>
    <v-form>
        <v-row>
            <v-col cols="12" >
                <v-text-field
                    label="Name"
                    v-model="form.name"
                    outlined
                    dense
                    hide-details="auto"
                    clearable
                >
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-text-field
                    label="Code"
                    v-model="form.code"
                    outlined
                    dense
                    hide-details="auto"
                    clearable
                >
                </v-text-field>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    name: "WarehouseListSearch",
    data() {
        return {
            form: {
                name: "",
                code: ""
            }
        }
    },
    computed: {
        ...mapGetters({
            params: "warehouse/warehouse/list/params"
        })
    },
    methods: {
        ...mapActions({
            updateParams: "warehouse/warehouse/list/updateParams"
        }),
        submit() {
            this.updateParams(this.form)
        }
    }
}
</script>

<style>

</style>